import axios from 'axios';
import type { LatLng } from '@/shared/types/coords.schema';
import type { GraphHopperRouteResponse } from '@/shared/types/graphHopper.types';

const GRAPHHOPPER_BASE_URL = import.meta.env.VITE_GRAPHHOPPER_BASE_URL;

type GetDirectionParams = {
	origin: LatLng;
	destination: LatLng;
};

const graphHopperApi = {
	getDirection: async ({
		origin,
		destination,
	}: GetDirectionParams): Promise<GraphHopperRouteResponse> => {
		const params = new URLSearchParams({
			profile: 'car',
			locale: 'ko',
			instructions: 'false',
			calc_points: 'false',
		});
		params.append('point', `${origin.lat},${origin.lng}`);
		params.append('point', `${destination.lat},${destination.lng}`);

		const response = await axios.get<GraphHopperRouteResponse>(
			`${GRAPHHOPPER_BASE_URL}/route?${params.toString()}`,
		);

		return response.data;
	},
};

export default graphHopperApi;
